module.exports = __webpack_public_path__ + "img/dollar_sign.2e56951f.png";